import React from "react";
import { formatDateTime } from "../utils";

const LogsSidebar = ({ logs, selectedLogId, onSelect }) => {
  return (
    <aside className="logs-sidebar">
      <div className="logs-sidebar-header">
        <h3>Event List</h3>
        <span>{logs.length} entries</span>
      </div>

      <div className="logs-sidebar-list">
        {logs.map((log) => (
          <button
            key={log.id}
            className={`logs-sidebar-item ${
              selectedLogId === log.id ? "active" : ""
            }`}
            onClick={() => onSelect(log.id)}
            type="button"
          >
            <div className="logs-sidebar-item-top">
              <strong>{log.title}</strong>
              <small>{formatDateTime(log.eventTime)}</small>
            </div>
            <div className="logs-sidebar-item-sub">
              <span>{log.serviceName || "Unknown service"}</span>
              <span>{log.actorLabel}</span>
            </div>
          </button>
        ))}
      </div>
    </aside>
  );
};

export default LogsSidebar;
